import type { MarketAccount } from '../../contexts/MarketAccountsContext';
import { Order } from '../../types/Order';

type RowMarketFields = {
  Market?: string;
  MarketAccount?: string;
};

/**
 * Every row type records its venue differently: orders spread across a Markets array, trades name the
 * venue directly, and positions only reference the market account they were traded on.
 */
export function resolveRowTradedMarket(
  data: unknown,
  marketAccountsByName: ReadonlyMap<string, Pick<MarketAccount, 'Market'>> | undefined
): string | undefined {
  if (data instanceof Order) {
    return data.tradedMarkets[0] ?? data.selectedMarkets[0];
  }

  const row = data as RowMarketFields | undefined;
  if (row?.Market) {
    return row.Market;
  }
  if (row?.MarketAccount) {
    return marketAccountsByName?.get(row.MarketAccount)?.Market;
  }
}
